export default "__VITE_ASSET__zTPQ7bFJ__"